/**
 * Owner: Masa Bayu
 * File: qxp-artifact-sample-scope.ts
 * Date:Time: 2026-10-29 11:36
 * Description: Skop muatan Read Sample — hanya sampleContentRefs / halaman sampel.
 */

const CONTENT_PREFIX = 'content/';

export function contentRelFromTargetRef(targetRef: string): string {
  return targetRef.replace(/^[a-z][a-z0-9+-]*:\/\//i, '');
}

export function parseSampleContentPaths(raw: unknown): readonly string[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const out: string[] = [];
  for (const item of raw) {
    if (typeof item !== 'string' || !item.startsWith(CONTENT_PREFIX)) {
      continue;
    }
    if (item.includes('..') || item.startsWith('/') || item.includes('\\')) {
      continue;
    }
    out.push(item);
  }
  return out;
}

export function isUnderlayContentPath(path: string): boolean {
  return /^content\/page-\d+\.json$/.test(path);
}

function pageOfTargetRef(targetRef: string): number | null {
  const match = /el_p(\d+)_(?:line|para)_(\d+)/.exec(targetRef);
  if (match === null) {
    return null;
  }
  const page = Number.parseInt(match[1] ?? '', 10);
  return Number.isInteger(page) && page >= 1 ? page : null;
}

function parseSampleMaxPage(raw: unknown): number | null {
  if (typeof raw !== 'number' || !Number.isInteger(raw) || raw < 0) {
    return null;
  }
  return raw;
}

/** null = bukan mod sampel (semua rujukan pakej). Array (mungkin kosong) = skop sampel. */
export function payloadTargetsForLoad(
  packageTargets: readonly string[],
  sample: boolean,
  sampleContentRefs: unknown,
  sampleMaxPage: unknown,
): readonly string[] {
  if (!sample) {
    return packageTargets;
  }
  const paths = parseSampleContentPaths(sampleContentRefs);
  if (paths.length > 0) {
    const allowedRel = new Set(
      paths
        .filter((path) => !isUnderlayContentPath(path))
        .map((path) => path.slice(CONTENT_PREFIX.length).replace(/\.json$/, '')),
    );
    return packageTargets.filter((target) => allowedRel.has(contentRelFromTargetRef(target)));
  }
  const maxPage = parseSampleMaxPage(sampleMaxPage);
  if (maxPage === null || maxPage <= 0) {
    return [];
  }
  return packageTargets.filter((target) => {
    const page = pageOfTargetRef(target);
    return page !== null && page <= maxPage;
  });
}

export function underlayPathsForLoad(
  pageUnderlays: unknown,
  sample: boolean,
  sampleContentRefs: unknown,
): unknown {
  if (!sample) {
    return pageUnderlays;
  }
  const allowed = new Set(parseSampleContentPaths(sampleContentRefs));
  if (!Array.isArray(pageUnderlays)) {
    return [];
  }
  if (allowed.size === 0) {
    return [];
  }
  return pageUnderlays.filter((path) => typeof path === 'string' && allowed.has(path));
}
